/**
 * @author RamaTulasi <rama.tulasi@sollishealth.com>
 */
import React, { useEffect, useState } from 'react';
import {
    Container,
    Row,
    Col,
    Form,
    FormGroup,
    Label,
    Input,
    FormText,
    TabContent,
    TabPane,
    Nav,
    NavItem,
    NavLink,
    Card,
    Button,
    CardTitle,
    CardText,
} from 'reactstrap';
import { Link, useParams, useHistory } from 'react-router-dom';
import classnames from 'classnames';
import Autosuggest from 'react-autosuggest';
import { useSelector, useDispatch } from 'react-redux';
import { storeSpecialities } from '../../features/specialitiesSlice';
import { Modal, ModalFooter, ModalHeader, ModalBody } from 'reactstrap';
import Avatar from 'react-avatar';
import { addNewAppointment, messageRequest, saveMessageContentRequest, GetSpecialty } from '../../services/RestApi';
import { SYSTEM_ERROR_PAGE } from '../../utilities/Constants';
import { checkVersionDiff } from '../../utilities/helper';


function SpecialistReferral() {
    let history = useHistory();
    const _specialistDetails = useSelector(
        (state) => state.specialities.specialities
    );
    const [memberDetails, setMemberDetails] = useState({});
    const [suggestions, setSuggestions] = useState([]);
    const [specialists, setSpecialists] = useState([]);
    const [physicianRefer, setPhysicianRefer] = useState('Sollis');
    const _memberDetails = useSelector((state) => state.memberDetails);
    const [referer, setReferer] = useState('Sollis');
    const [activeTab, setActiveTab] = useState(
        _memberDetails?.loginMember[0]?.patientID
    );
    let textInput = null;
    const [modal, setModal] = React.useState(false);
    const [noDependents, setNoDependents] = useState(false);
    let { groupId } = useParams();
    const dispatch = useDispatch();
    const _appointmentTypes = useSelector(
        (state) => state.appointmentTypes.appointmentTypes
    );
    const [suggestion, setSuggestion] = useState({});
    const [reason, setReason] = useState('');
    const [error, setError] = useState('');
    const [activeGroup, setActiveGroup] = useState({});
    const [callBackNumber, setCallBackNumber] = useState('');
    const [additionalDetails, setAdditionalDetails] = useState('');
    const [inputValue, setInputValue] = useState('');
    const [loading, setLoading] = useState(false);
    const [showAptLoader, setShowAptLoader] = useState(false);
    // Toggle for Modal
    const toggle1 = () => setModal(!modal);
    /**
     * calculating whether to display addmember link or not
     * In case all dependents are added no need to add addmember link
     */
    useEffect(() => {
        getGroupDetails();
        let memberDetails = _memberDetails || {};
        let flag = true;
        if (
            memberDetails &&
            memberDetails.dependents &&
            memberDetails.dependents.length
        ) {
            memberDetails.dependents.map((d) => {
                if (!d.selected) {
                    flag = false;
                }
            });
        } else {
            flag = true;
        }
        setNoDependents(false);
        setMemberDetails(memberDetails);
    }, []);

    /**
     *
     * @param {*} tab : setting current active member
     */
    const toggle = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
            getCallBackNumber(tab);
        }
        changeRefrerer(physicianRefer, tab);
    };
    /**
     * retreving the specialist details from the store
     */
    useEffect(() => {
        _specialistDetails &&
            _specialistDetails.length &&
            setSpecialists(_specialistDetails);
    }, [_specialistDetails]);
    /**
     * retreving the specialist details from the api
     */
    useEffect(() => {
        !(_specialistDetails && _specialistDetails.length) &&
            GetSpecialty().then((resp) => {
                checkVersionDiff(dispatch, resp);
                setSpecialists(resp.data?.data[0]?.specialtys || []);
                dispatch(storeSpecialities(resp.data?.data[0]?.specialtys));
            }).catch(err => history.push(SYSTEM_ERROR_PAGE));
    }, []);
    /**
     *
     * @returns appointmentTypes group details
     */

    const getGroupDetails = () => {
        let group =
            _appointmentTypes?.find((a) => +a.groupId === +groupId) || {};
        setActiveGroup(group);
        
        return group;
    };
    /**
     * setting default acive tab as login member
     */
    useEffect(() => {
        setActiveTab(_memberDetails?.loginMember[0]?.patientID);
        getCallBackNumber(_memberDetails?.loginMember[0]?.patientID);
    }, [_memberDetails]);

    const getCallBackNumber = (tab) => {
        if (
            _memberDetails.loginMember &&
            tab === _memberDetails?.loginMember[0]?.patientID
        ) {
            let phone =
                _memberDetails?.loginMember[0]?.primaryPhoneNumber ||
                _memberDetails?.loginMember[0]?.secondaryPhoneNumber ||
                _memberDetails?.loginMember[0]?.mobileNumber ||
                '';
            const formattedPhoneNumber = formatPhoneNumber(phone);
            setCallBackNumber(formattedPhoneNumber);
        } else if (
            _memberDetails.dependents &&
            _memberDetails.dependents.length
        ) {
            let dependent =
                _memberDetails.dependents.find((d) => d.patientID === tab) ||
                {};
            let phone =
                dependent?.primaryPhoneNumber ||
                dependent?.secondaryPhoneNumber ||
                dependent?.mobileNumber ||
                '';
            const formattedPhoneNumber = formatPhoneNumber(phone);
            setCallBackNumber(formattedPhoneNumber);
        }
    };
    /**
     *
     * @param {*} param0 :searched string
     * setting the suggestions based on the user entry values
     */
    const onSuggestionsFetchRequested = ({ value }) => {
        setSuggestions(getSuggestions(value));
    };

    // Autosuggest will call this function every time you need to clear suggestions.
    const onSuggestionsClearRequested = (e) => {
        
        //setSuggestion({});
        setSuggestions([]);
    };
    // Teach Autosuggest how to calculate suggestions for any given input value.
    const getSuggestions = (value) => {
        const inputValue = value.trim().toLowerCase();
        const inputLength = inputValue.length;

        return inputLength === 0
            ? []
            : specialists
                .filter(
                    (speciality) =>
                        speciality.specialtyName
                            .toLowerCase()
                            .slice(0, inputLength) === inputValue
                )
                .slice(0, 10);
    };
    /**
     *  When suggestion is clicked, Autosuggest needs to populate the input
     *  based on the clicked suggestion. Teach Autosuggest how to calculate the
     *  input value for every given suggestion.
     */

    const getSuggestionValue = (suggestion) => {
        
        return suggestion;
    };
    const [value, setValue] = useState('');
    const onChange = (event, { newValue }) => {
        let s =
            typeof newValue === 'string'
                ? { specialtyID: null, specialtyName: newValue }
                : newValue;
        setSuggestion(s);

        setValue(
            typeof newValue === 'string' ? newValue : newValue.specialtyName
        );
    };
    /**
     * Autosuggest will pass through all these props to the input.
     */
    const inputProps = {
        placeholder: 'Type a Specialist',
        value,
        onChange: onChange,
        maxLength: 60,
    };

    // Use your imagination to render suggestions.
    const renderSuggestion = (suggestion) => (
        <div>{suggestion.specialtyName}</div>
    );
    /**
     *
     * @param {*} refer :currently selected refervalue
     * @param {*} tab : currently selected member
     */
    const changeRefrerer = (refer, tab) => {
        if (refer === 'Other') {
            setReferer('');
            textInput?.focus();
        } else if (refer === 'PCP') {
            let _referer = '';
            if (_memberDetails.loginMember[0]?.patientID === tab) {
                _referer =
                    _memberDetails.loginMember[0]?.primary_Physician || '';
            } else {
                _memberDetails.dependents.map((d) => {
                    if (d.patientID === tab) {
                        _referer = d.primary_Physician || '';
                    }
                });
            }
            setReferer(_referer);
        } else {
            setReferer('Sollis');
        }
    };
    /**
     *
     * @param {*} e :currently selected refervalue
     */

    const changeRefer = (e) => {
        
        setPhysicianRefer(e.target.value);
        changeRefrerer(e.target.value, activeTab);
    };

    const getPayload = () => {
        let group = getGroupDetails();
        let appointmentFor = getAppointmentFor();
        let appointmentRequestDetails = [];
        if (group.groupName === 'Specialist Referral') {
            appointmentRequestDetails = [
                {
                    specialtyID: suggestion?.specialtyID,
                    specialtyName: suggestion?.specialtyName,
                    referralReason: reason,
                    physicianName: referer,
                    appointmentFor: appointmentFor.patientID,
                    memberName: appointmentFor.memberUsername,
                    memberID: appointmentFor.memberID,
                },
            ];
        } else {
            appointmentRequestDetails = [
                {
                    appointmentFor: appointmentFor.patientID,
                    memberName: appointmentFor.memberUsername,
                    memberID: appointmentFor.memberID,
                    mobileNumber: callBackNumber,
                    remarks: additionalDetails,
                },
            ];
        }
        let payload = {
            addAppointmentRequest: {
                appointmentLastLevelID: group.groupId,
                appointmentFirstLevelDesc: group.groupName,
                memberId: memberDetails.loginMember[0]?.memberID,
                appointmentRequestDetails: JSON.stringify(
                    appointmentRequestDetails[0]
                ),
                memberInfo: '',
                detailsForTask: '',
                createdUser: memberDetails.loginMember[0]?.memberUsername,
            },
        };
        if (!suggestion?.specialtyID) {
            delete payload.addAppointmentRequest.appointmentRequestDetails[0]
                .specialtyID;
        }
        return payload;
    };
    /**
     * scheduling an appointment based on the user provided details
     */

     const getMessageDetails = () => {
        let group = getGroupDetails();
        let appointmentFor = getAppointmentFor();
        let appointmentRequestDetails = [];
        let message = '';
        var options = { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' };
        var today  = new Date();
        var dateString = today.toLocaleDateString("en-US", options);
        var apptFor =  _memberDetails?.loginMember[0]?.memberFullname;

        // TODO: Get Name
        

        if (group.groupName === 'Specialist Referral') {
            appointmentRequestDetails = [
                {
                    specialtyID: suggestion?.specialtyID,
                    specialtyName: suggestion?.specialtyName,
                    referralReason: reason,
                    physicianName: referer,
                    appointmentFor: appointmentFor.patientID,
                    memberName: appointmentFor.memberUsername,
                    memberID: appointmentFor.memberID,
                },
            ];
            message = `Type: Specialist Referral\r\nRequest Date: ${dateString}\r\nStatus: New\r\nFor Member: ${apptFor}\r\nAppointment For: ${apptFor}\r\nSpeciality Name: ${appointmentRequestDetails[0].specialtyName}\r\n Referral Reason: ${appointmentRequestDetails[0].referralReason}\r\n Physician Name: ${appointmentRequestDetails[0].physicianName}\r\n\r\n Member ID: ${appointmentRequestDetails[0].memberID}`;
            //message = `Appointment For: ${appointmentRequestDetails[0].appointmentFor}\r\n Specialty ID: ${appointmentRequestDetails[0].specialtyID}\r\n Speciality Name: ${appointmentRequestDetails[0].specialtyName}\r\n Referral Reason: ${appointmentRequestDetails[0].referralReason}\r\n Physician Name: ${appointmentRequestDetails[0].physicianName}\r\n Member Name: ${appointmentRequestDetails[0].memberName}\r\n Member ID: ${appointmentRequestDetails[0].memberID}`;
        } else {
            appointmentRequestDetails = [
                {
                    appointmentFor: appointmentFor.patientID,
                    memberName: appointmentFor.memberUsername,
                    memberID: appointmentFor.memberID,
                    mobileNumber: callBackNumber,
                    remarks: additionalDetails,
                },
            ];
            message = `Type: Appointment Request\r\nRequest Date: ${dateString}\r\nStatus: New\r\nFor Member: ${apptFor}\r\nMember ID: ${appointmentRequestDetails[0].memberID}\r\nAppointment For: ${apptFor}\r\n Mobile Number: ${callBackNumber}\r\nRemarks: ${appointmentRequestDetails[0].remarks}`;
        }

        return message;
     };

    const createAppointment = () => {
        setShowAptLoader(true)
        setModal(true);
        setLoading(true);
        let message = getMessageDetails() + ' ';
        let payload = {
           externalId: 'Preventice Care',
           header: `Specialist Referral Request`,
           type: `Specialist Referral Request`
       };
        setError('');
        messageRequest(payload)
           .then((res) => {
            checkVersionDiff(dispatch, res);
            setShowAptLoader(false)
               const data = res.data;
               payload = {
                   conversationId: data.conversationId,
                   externalId: data.externalId,
                   content: message,
                   staffMemberSentBy:  _memberDetails?.loginMember[0]?.memberFullname
               }
               saveMessageContentRequest(payload).then((res) =>{
                checkVersionDiff(dispatch, res);
               })
               .catch((e) => {
                setShowAptLoader(false)
                   //notify('Message not sent','error');
                   setError('Something went wrong!!');
                }); 
           })
           .catch((e) => {
            setShowAptLoader(false)
              //notify('Message not sent','error');
              setError('Something went wrong!!');
           })
           .finally(() => {
               setLoading(false);
           });
    };

    const addAppointment = () => {
        
        setModal(true);
        setLoading(true);
        let payload = getPayload();
        
        setError('');
        addNewAppointment(payload)
            .then((res) => { checkVersionDiff(dispatch, res); })
            .catch((e) => {
                setError('Something went wrong!!');
            })
            .finally(() => {
                setLoading(false);
            });
    };
    const getAppointmentFor = () => {
        if (
            memberDetails.loginMember &&
            activeTab === memberDetails?.loginMember[0]?.patientID
        ) {
            return memberDetails?.loginMember[0];
        } else if (
            memberDetails.dependents &&
            memberDetails.dependents.length
        ) {
            return (
                memberDetails.dependents.find(
                    (d) => d.patientID === activeTab
                ) || {}
            );
        }
        return {};
    };
    const handleInput = (e) => {
        // this is where we'll call our future formatPhoneNumber function that we haven't written yet.
        const formattedPhoneNumber = formatPhoneNumber(e.target.value);
        // we'll set the input value using our setInputValue
        setCallBackNumber(formattedPhoneNumber);
    };

    const formatPhoneNumber = (value) => {
        // if input value is falsy eg if the user deletes the input, then just return
        if (!value) return value;

        // clean the input for any non-digit values.
        const phoneNumber = value.replace(/[^\d]/g, '');

        // phoneNumberLength is used to know when to apply our formatting for the phone number
        const phoneNumberLength = phoneNumber.length;

        // we need to return the value with no formatting if its less then four digits
        // this is to avoid weird behavior that occurs if you  format the area code to early

        if (phoneNumberLength < 4) return phoneNumber;

        // if phoneNumberLength is greater than 4 and less the 7 we start to return
        // the formatted number
        if (phoneNumberLength < 7) {
            return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
        }

        // finally, if the phoneNumberLength is greater then seven, we add the last
        // bit of formatting and return it.
        return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(
            3,
            6
        )}-${phoneNumber.slice(6, 10)}`;
    };

    return (
        <Container className="special-referral margin-top-large">
            <Row className="section-header">
                <Col lg="12">
                    <div className="float-left">
                        <i
                            className="bi-chevron-left"
                            onClick={history.goBack}
                        />
                    </div>
                    <div className="float-right">
                        {!noDependents ? (
                            <Link to={`/multimember?cf=lr`}>
                                <i className="bi-plus" />
                            </Link>
                        ) : (
                            ''
                        )}
                        {memberDetails && memberDetails.loginMember && (
                            <>
                                <div className="profile-icon">
                                    <Avatar
                                        className="imgBg"
                                        salesforceID={
                                            memberDetails?.loginMember[0]
                                                ?.salesforceID
                                        }
                                        size="40"
                                        name={
                                            memberDetails?.loginMember[0]
                                                ?.memberUsername
                                        }
                                        round={true}
                                    />
                                    {memberDetails.dependents.map(
                                        (d, index) =>
                                            d.selected && (
                                                <Avatar
                                                    key={index}
                                                    className="imgBg"
                                                    salesforceID={
                                                        d.salesforceID
                                                    }
                                                    name={d.memberUsername}
                                                    size="40"
                                                    round={true}
                                                />
                                            )
                                    ) || ''}
                                </div>
                            </>
                        )}
                    </div>
                </Col>
            </Row>
            <Row>
                <Col className="grayBg">
                    {activeGroup.groupName === 'Specialist Referral' ? (
                        <h1>Please tell us about your referral request.</h1>
                    ) : (
                        <h1>Please tell us more about your Virtual Visit.</h1>
                    )}
                </Col>
            </Row>
            <Row className="referral-tab">
                <Col lg="8">
                    <div className="add-member">
                        <span className="float-left">Who is this for?</span>
                        {!noDependents ? (
                            <Link to={`/multimember?cf=sr&groupId=${groupId}`}>
                                <span className="float-right link">
                                    <i className="bi-plus bold" /> Add Member
                                </span>
                            </Link>
                        ) : (
                            ''
                        )}
                    </div>
                    <div className="clearfix" />
                    <div>
                        <Nav tabs>
                            <NavItem>
                                <NavLink
                                    className={classnames({
                                        active:
                                            activeTab ===
                                            _memberDetails?.loginMember[0]
                                                ?.patientID,
                                    })}
                                    onClick={() => {
                                        toggle(
                                            _memberDetails?.loginMember[0]
                                                ?.patientID
                                        );
                                    }}
                                >
                                    {
                                        _memberDetails?.loginMember[0]
                                            ?.memberUsername
                                    }
                                </NavLink>
                            </NavItem>
                            {_memberDetails?.dependents
                                ?.filter((d) => d.selected)
                                .map((d, index) => (
                                    <NavItem key={index}>
                                        <NavLink
                                            className={classnames({
                                                active:
                                                    activeTab === d.patientID,
                                            })}
                                            onClick={() => {
                                                toggle(d.patientID);
                                            }}
                                        >
                                            {d.memberUsername}
                                        </NavLink>
                                    </NavItem>
                                ))}
                        </Nav>
                        <TabContent>
                            <TabPane>
                                <Row>
                                    <Col sm="12">
                                        <Form>
                                            {activeGroup.groupName ===
                                                'Specialist Referral' ? (
                                                <>
                                                    <FormGroup>
                                                        <Label for="specialist">
                                                            What type of
                                                            specialist do you
                                                            need?
                                                        </Label>
                                                        <Autosuggest
                                                            suggestions={
                                                                suggestions
                                                            }
                                                            onSuggestionsFetchRequested={
                                                                onSuggestionsFetchRequested
                                                            }
                                                            onSuggestionsClearRequested={
                                                                onSuggestionsClearRequested
                                                            }
                                                            getSuggestionValue={
                                                                getSuggestionValue
                                                            }
                                                            renderSuggestion={
                                                                renderSuggestion
                                                            }
                                                            inputProps={
                                                                inputProps
                                                            }
                                                        />
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Label for="physician">
                                                            Referring Physician
                                                        </Label>
                                                        <Label
                                                            check
                                                            className="float-right"
                                                        >
                                                            <span className="select">
                                                                <Input
                                                                    id="Sollis"
                                                                    onChange={
                                                                        changeRefer
                                                                    }
                                                                    value="Sollis"
                                                                    type="radio"
                                                                    name="physicianRefer"
                                                                    defaultChecked
                                                                />{' '}
                                                                <label for="Sollis">
                                                                    Sollis
                                                                </label>
                                                            </span>
                                                            <span className="select">
                                                                <Input
                                                                    id="PCP"
                                                                    onChange={
                                                                        changeRefer
                                                                    }
                                                                    value="PCP"
                                                                    type="radio"
                                                                    name="physicianRefer"
                                                                />{' '}
                                                                <label for="PCP">
                                                                    PCP
                                                                </label>
                                                            </span>
                                                            <span className="select">
                                                                <Input
                                                                    id="Other"
                                                                    onChange={
                                                                        changeRefer
                                                                    }
                                                                    value="Other"
                                                                    type="radio"
                                                                    name="physicianRefer"
                                                                />{' '}
                                                                <label for="Other">
                                                                    Other
                                                                </label>
                                                            </span>
                                                        </Label>
                                                        {physicianRefer ==
                                                            'Other' ? (
                                                            <Input
                                                                type="text"
                                                                placeholder="Enter Physician Name & PhoneNumber"
                                                                name="physician"
                                                                id="physician"
                                                                onChange={(e) =>
                                                                    setReferer(
                                                                        e.target
                                                                            .value
                                                                    )
                                                                }
                                                                value={referer}
                                                                ref={(
                                                                    input
                                                                ) => {
                                                                    textInput =
                                                                        input;
                                                                }}
                                                                maxLength="50"
                                                            />
                                                        ) : (
                                                            <Input
                                                                type="text"
                                                                placeholder="Enter Physician Name & PhoneNumber"
                                                                name="physician"
                                                                id="physician"
                                                                onChange={(e) =>
                                                                    setReferer(
                                                                        e.target
                                                                            .value
                                                                    )
                                                                }
                                                                value={referer}
                                                                ref={(
                                                                    input
                                                                ) => {
                                                                    textInput =
                                                                        input;
                                                                }}
                                                                maxLength="50"
                                                            />
                                                        )}
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Label for="reason">
                                                            Reason for referral?
                                                        </Label>
                                                        <p className="error">
                                                            <sup>*</sup>
                                                            Required
                                                        </p>
                                                        <Input
                                                            type="textarea"
                                                            name="reason"
                                                            onChange={(e) =>
                                                                setReason(
                                                                    e.target
                                                                        .value
                                                                )
                                                            }
                                                            maxLength="250"
                                                        />
                                                    </FormGroup>
                                                </>
                                            ) : (
                                                <>
                                                    <FormGroup>
                                                        <Label for="phonenumber">
                                                            Best call back
                                                            number:
                                                        </Label>
                                                        <span className="text-danger">
                                                            {' '}
                                                            required
                                                        </span>

                                                        <Input
                                                            type="tel"
                                                            name="callBackNumber"
                                                            value={
                                                                callBackNumber
                                                            }
                                                            onChange={(e) =>
                                                                handleInput(e)
                                                            }
                                                            placeholder="Enter PhoneNumber"
                                                            maxLength="12"
                                                            required
                                                        />
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Label for="details">
                                                            Additional Details
                                                        </Label>
                                                        <Input
                                                            type="textarea"
                                                            name="additionalDetails"
                                                            onChange={(e) =>
                                                                setAdditionalDetails(
                                                                    e.target
                                                                        .value
                                                                )
                                                            }
                                                            maxLength="250"
                                                        />
                                                    </FormGroup>
                                                </>
                                            )}
                                            <FormGroup className="upload">
                                                <div className="float-left">
                                                    <Label
                                                        type="file"
                                                        for="exampleFile"
                                                        className="link"
                                                    >
                                                        attach file{' '}
                                                        <i className="bi-paperclip" />
                                                    </Label>
                                                    <Input
                                                        type="file"
                                                        name="file"
                                                        id="file"
                                                    />
                                                </div>
                                                <div className="float-left offset-lg-1">
                                                    <Label
                                                        for="exampleFile"
                                                        className="link"
                                                    >
                                                        attach photo{' '}
                                                        <i className="bi-camera" />
                                                    </Label>
                                                    <Input
                                                        type="file"
                                                        name="file"
                                                        id="photo"
                                                    />
                                                </div>
                                            </FormGroup>
                                            <FormGroup className="referral-btn">
                                                {/* <Link to="/appointmenttype"> */}
                                                <div
                                                    className="button-action btn-gray"
                                                    onClick={history.goBack}
                                                >
                                                    Back
                                                </div>
                                                {/* </Link> */}
                                                {activeGroup.groupName ===
                                                    'Specialist Referral' ? (
                                                    <div
                                                        className={
                                                            reason.trim()
                                                                ? 'button-action btn-light'
                                                                : 'button-action btn-gray button-action-not-allowed'
                                                        }
                                                        onClick={createAppointment}
                                                    >
                                                        Next
                                                    </div>
                                                ) : (
                                                    <div
                                                        className={
                                                            callBackNumber.length >
                                                                11
                                                                ? 'button-action btn-light'
                                                                : 'button-action btn-gray button-action-not-allowed'
                                                        }
                                                        onClick={createAppointment}
                                                    >
                                                        Next
                                                    </div>
                                                )}
                                                <Modal
                                                    modalClassName='solis-modal2 apt-edit apt-loading'
                                                    isOpen={showAptLoader}
                                                    backdrop={true}
                                                    centered={true}
                                                >
                                                    <ModalBody>
                                                        <div className='apt-loading-img'>
                                                            <img
                                                                src='/images/appointment-webtechops.svg'
                                                                alt='appointment-webtechops'
                                                                className='svg-appointment-loading'
                                                            />
                                                        </div>
                                                        <div className='apt-loading-body'>
                                                            <h4>Creating your appointment</h4>
                                                            <p className='apt-loading-txt'>
                                                                <span>This might take a minute.</span>
                                                                <br />
                                                                <span>Thank you for your patience.</span>
                                                            </p>
                                                        </div>
                                                        <div id="loaders" class="divShow spinner">
                                                            <div class="global-spinner">
                                                                <div></div>
                                                                <div></div>
                                                                <div></div>
                                                                <div></div>
                                                                <div></div>
                                                                <div></div>
                                                                <div></div>
                                                                <div></div>
                                                                <div></div>
                                                                <div></div>
                                                                <div></div>
                                                                <div></div>
                                                            </div>
                                                        </div>
                                                    </ModalBody>
                                                </Modal>
                                                <Modal
                                                    className="solis-modal"
                                                    isOpen={modal}
                                                    toggle={toggle1}
                                                >
                                                    {/* <Header /> */}
                                                    <ModalHeader
                                                        toggle={toggle1}
                                                    >
                                                        {loading
                                                            ? 'Request is in progress'
                                                            : 'Thank You!'}
                                                        {/* <i className='bi-x-circle btn-close' aria-label='close'/> */}
                                                    </ModalHeader>
                                                    <ModalBody>
                                                        {loading ? (
                                                            <div className="working mt-3"></div>
                                                        ) : error ? (
                                                            <p>{error}</p>
                                                        ) : (
                                                            <>
                                                                <p>
                                                                    {' '}
                                                                    We have received your specialist referral request.{' '}
                                                                </p>
                                                                <p>
                                                                    One of our team members will contact you to discuss next steps.
                                                                </p>
                                                            </>
                                                        )}
                                                    </ModalBody>
                                                    <ModalFooter>
                                                        <Link
                                                            to="/specialistreferrallist"
                                                            className="btn-link"
                                                        >
                                                            <Button className="button-action btn-light">
                                                                CONTINUE
                                                            </Button>
                                                        </Link>
                                                    </ModalFooter>
                                                </Modal>
                                            </FormGroup>
                                        </Form>
                                    </Col>
                                </Row>
                            </TabPane>
                        </TabContent>
                    </div>
                </Col>
            </Row>
        </Container>
    );
}

export default SpecialistReferral;
